import { render, staticRenderFns } from "./MyBillDetail.vue?vue&type=template&id=62f3a74c&scoped=true"
import script from "./MyBillDetail.vue?vue&type=script&lang=js"
export * from "./MyBillDetail.vue?vue&type=script&lang=js"
import style0 from "./MyBillDetail.vue?vue&type=style&index=0&id=62f3a74c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f3a74c",
  null
  
)

export default component.exports